export default {
  name: "TableExpand",
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    field: {
      type: Object,
      default: null
    }
  },
  render: (h, ctx) => {
    const params = {
      row: ctx.props.row,
      index: ctx.props.index
    };
    if (ctx.props.field) params.field = ctx.props.field;
    return ctx.props.render(h, { ...ctx.props, params });
  }
};
